module.exports = __webpack_public_path__ + "media/images/athletes/2834-708026f8014bf9fbcd90cd729a21fb98.png";